import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationModalService } from '../components/confirmation-modal/confirmation-modal.service';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Promise<boolean>;
}

@Injectable()
export class PendingChangesGuard implements CanDeactivate<ComponentCanDeactivate> {
  constructor(private confirmationService: ConfirmationModalService, private translate: TranslateService) {}

  canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> {
    if (component.canDeactivate()) {
      return true;
    }

    return new Promise(resolve => {
      this.confirmationService.show({
        message: () => this.translate.instant('app.navigation.unsaved-changes-warning'),
        accept: () => resolve(true),
        reject: () => resolve(false),
      });
    });
  }
}
